import styled from 'styled-components';
import PropTypes from 'prop-types';

const FormSectionHeading = styled.div`
    display: flex;
    align-items: center;
    height: 24px;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.88px;
    line-height: 24px;
    text-transform: ${props => (props.textTransform ? props.textTransform : 'uppercase')};
    margin: ${props => (props.marginTop ? props.marginTop : 25)}px 0px ${props => 5 + (props.marginBottomModifier || 0)}px;
`;

FormSectionHeading.propTypes = {
    marginBottomModifier: PropTypes.number,
    marginTop: PropTypes.number,
    textTransform: PropTypes.string
};

export default FormSectionHeading;



// WEBPACK FOOTER //
// ./src/components/atoms/form/FormSectionHeading.js